import {Card, Text} from '@mantine/core'

type SectionCardProps = {
    title: React.ReactNode
    children: React.ReactNode
    bodyPadding?: 'pt-md' | 'py-md'
}

export function SectionCard({title, children, bodyPadding = 'pt-md'}: SectionCardProps) {
    const bodyPaddingProps = bodyPadding === 'py-md' ? {py: 'md' as const} : {pt: 'md' as const}

    return (
        <Card padding="md" style={{borderLeft: '3px solid var(--mantine-color-green-6)'}}>
            <Card.Section
                inheritPadding
                py="sm"
                style={{backgroundColor: 'var(--mantine-color-green-0)'}}
            >
                {typeof title === 'string' ? (
                    <Text fw={600} size="lg">
                        {title}
                    </Text>
                ) : (
                    title
                )}
            </Card.Section>
            <Card.Section inheritPadding pb="md" {...bodyPaddingProps}>
                {children}
            </Card.Section>
        </Card>
    )
}
